import { useState } from "react";

import { getEmployeeList } from "src/apis/employeeApi";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

import {
	defaultTQC2011_R01Filter,
	useTQC2011_R01Store,
} from "./Store_TQC2011_R01";

export const SearchSection_TQC2011_R01 = () => {
	const { TQC2011_R01Filter, setTQC2011_R01Filter } = useTQC2011_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { compCdList, workPlaceList } = useCommonCodeStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
	const itemFocusId = "tqc2011_itemCd_search";
	const employeeFocusId = "tqc2011_productEmp_search";

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "itemCd",
			category: "품목",
			focusId: itemFocusId,
			responseMapping: { itemCd: "itemCd", itemNm: "itemNm" },
			searchFunction: async (searchText: string) => {
				const response = await getItemPopupList(searchText, "", "", "");
				return response.data.data.find((value) => value.itemCd === searchText);
			},
		},
		{
			fieldName: "productEmp",
			category: "담당자",
			focusId: employeeFocusId,
			responseMapping: { empNo: "productEmp", empNm: "productEmpNm" },
			searchFunction: async (searchText: string) => {
				const response = await getEmployeeList("all");
				return response.data.data.find((value) => value.empNo === searchText);
			},
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: TQC2011_R01Filter,
		setEditData: setTQC2011_R01Filter,
		defaultData: defaultTQC2011_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "TQC2011_R01_search",
	});

	const expandSearch = () => (
		<>
			<SearchCodeModalForm
				label="품목코드"
				value={TQC2011_R01Filter.itemCd}
				valueLabel={TQC2011_R01Filter.itemNm}
				handleFoucsId={itemFocusId}
				onChange={getFieldHandlers("itemCd").onChange}
				onDoubleClick={getFieldHandlers("itemCd").onDoubleClick}
				onKeyDown={getFieldHandlers("itemCd").onEnterKeyDown}
			/>
			<SearchCodeModalForm
				label="작업자"
				value={TQC2011_R01Filter.productEmp}
				valueLabel={TQC2011_R01Filter.productEmpNm}
				handleFoucsId={employeeFocusId}
				onChange={getFieldHandlers("productEmp").onChange}
				onDoubleClick={getFieldHandlers("productEmp").onDoubleClick}
				onKeyDown={getFieldHandlers("productEmp").onEnterKeyDown}
			/>
		</>
	);

	return (
		<SearchSectionForm expandSearch={expandSearch}>
			<SearchDropDownForm
				label="사업장"
				value={TQC2011_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={(compCd) => setTQC2011_R01Filter({ compCd })}
			/>
			<SearchDateRangeForm
				label="생산기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={TQC2011_R01Filter.dateRange}
				setDateRange={(dateRange) => setTQC2011_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm
				label="작업장"
				value={TQC2011_R01Filter.workplaceCd}
				optionList={workPlaceList}
				onChangeValue={(workplaceCd) => setTQC2011_R01Filter({ workplaceCd })}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_TQC2011_R01;
